import {
  Modal,
  ModalProps,
  LoadingSpinner,
} from '@rabbit/elements/shared-components';
import { useContext, useEffect, useState } from 'react';
import { FBD_Consumer_Private } from '@rabbit/data/types';
import { useMyConsumerPersona } from '@rabbit/data/portal';
import { useTranslation } from 'react-i18next';
import { AppContext } from '@rabbit/app-context';
import { toast } from 'react-toastify';
import { DTConsumer_Private } from '@rabbit/data/types';
import {
  DR_Consumer_Private,
  usePortalDocumentEditor,
} from '@rabbit/data/portal';
import { Navigate, NavLink } from 'react-router-dom';
import { DRDocType } from '@rabbit/firebase/react';
import ROUTE_NAME from '@rabbit/olive/utils/url-constants';

export function ModalTermsConditions() {
  const { t } = useTranslation();
  const { config, tenantInfo } = useContext(AppContext);
  const consumerPersona = useMyConsumerPersona();
  const consumerPersonaData = consumerPersona?.data.consumer_private;

  const [showTerms, setShowTerms] = useState(false);

  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const [modalSettings, setModalSettings] = useState<ModalProps>(
    {} as ModalProps
  );

  // if (!consumerPersonaId || !consumerPersonaData) return;
  const TERMS_LAST_UPDATE_DATE = new Date('2022-09-01').getTime(); //Last update date Unix timestamp
  const display =
    consumerPersonaData &&
    consumerPersonaData?.acceptedTerms < TERMS_LAST_UPDATE_DATE;

  // If user is being redirected to claim after NLIC. Extremely hacky, I know.
  const NLIC_RedirectTo = window.localStorage.getItem('NLIC_RedirectTo');

  const renderTenantTermsConditions = (): string => {
    const isSupagard = t('tenantLink') === 'SUPAGARD';

    return `
    <section class="mt-4 text-center">
      <div class="inline-block text-left">
        By continuing, you agree to:
        <ol class="mt-2 list-inside list-decimal">
          ${
            !isSupagard &&
            t('CFG_WARRANTY_INFO_URL') !== 'CFG_WARRANTY_INFO_URL'
              ? `
            <li>
              <a href="${t(
                'CFG_WARRANTY_INFO_URL'
              )}" target="_blank" rel="noopener noreferrer">
                ${tenantInfo?.name}’s Terms & Conditions
              </a>
            </li>
          `
              : ''
          }

          ${
            config?.LEGAL?.PRIVACY_POLICY_URL
              ? `
            <li>
              <a href="${config.LEGAL.PRIVACY_POLICY_URL}" target="_blank" rel="noopener noreferrer">
                ${tenantInfo?.name}’s Privacy Policy
              </a>
            </li>
          `
              : ''
          }

          <li>
            <a target="_blank" rel="noopener noreferrer" href="${
              ROUTE_NAME.TERMS_AND_CONDITIONS
            }">iWarranty’s Terms & Conditions</a>
          </li>
          <li>
            <a target="_blank" rel="noopener noreferrer" href="${
              ROUTE_NAME.PRIVACY_POLICY
            }">iWarranty’s Privacy Policy</a>
          </li>
        </ol>
      </div>
    </section>
  `;
  };

  const modalSettingsOptions = {
    warning: {
      kind: 'pop-up' as const,
      settings: {
        text: `In order to use iWarranty, please read and confirm that you accept our terms and conditions. ${renderTenantTermsConditions()}`,
        primaryButtonText: 'Confirm',
        outlineButtonText: 'View Terms',
        handlePrimaryClick: () => onAcceptTerms(),
        handleOutlineClick: () => onShowTerms(),
      },
    },
    terms: {
      kind: 'tc' as const,
      settings: {
        title: 'Terms and conditions',
        text: '', //hardcoded in TextModal.tsx
        primaryButtonText: 'I accept',
        handleClose: () => onShowWarning(),
        handlePrimaryClick: () => onAcceptTerms(),
      },
      className: 'w-full max-w-[729px] bg-white',
    },
  };

  const updateTerms = async () => {
    setLoading(true);
    document.body.style.overflow = 'auto';
    try {
      consumerPersonaData &&
        (await FBD_Consumer_Private.set({
          ...consumerPersonaData,
          acceptedTerms: Math.floor(new Date().getTime()),
        }));
    } catch (error) {
      toast.error('Error accepting terms and conditions');
      console.log('error', error);
    } finally {
      setLoading(false);
      setShowTerms(false);
    }
  };

  const onAcceptTerms = () => {
    setAccepted(true);
  };

  const onShowWarning = () => {
    setModalSettings(modalSettingsOptions.warning);
  };

  const onShowTerms = () => {
    setModalSettings(modalSettingsOptions.terms);
  };

  useEffect(() => {
    if (accepted) void updateTerms();
  }, [accepted]);

  useEffect(() => {
    onShowWarning();
  }, []);

  useEffect(() => {
    setShowTerms(display || false);
  }, [display]);

  const renderTermsAndConditions = () => {
    // Removing this, modal handles overflow internally
    // document.body.style.overflow = 'hidden';
    return (
      <Modal
        kind={modalSettings?.kind}
        settings={modalSettings.settings}
        className={modalSettings.className}
      />
    );
  };

  return showTerms ? (
    loading ? (
      <div className="fixed left-0 top-0 z-50 m-auto flex h-full w-full flex-wrap content-center justify-center bg-white/90">
        <LoadingSpinner size="md" isFullScreen />
      </div>
    ) : (
      renderTermsAndConditions()
    )
  ) : NLIC_RedirectTo ? (
    <Navigate to={NLIC_RedirectTo} />
  ) : null;
}

export default ModalTermsConditions;
